window.onload = function () {
  if (Shopify.locale == "en") {
    if (document.getElementById("rfwidget")) {
      document.getElementById("rfwidget").style.display = "none";
    }
    if (document.getElementById("ur-custom-widget")) {
      document.getElementById("ur-custom-widget").style.display = "none";
    }
  }
};

// $(document).ready(function () {
//   $("button.rf--add-to-cart").click(function () {
//     setTimeout(() => {
//       document.querySelector(".overlay").classList.toggle("active");
//       document.getElementById("cart-bag").classList.toggle("-active");
//     }, 1000);
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  var cartBag = document.getElementById("cart-bag");
  console.log(cartBag); // Check if it's not null
  // Your additional code here
});
